import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-3 gap-2 lg:gap-5" }

import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourcesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Resources")
      ])),
      _: 1,
      __: [0]
    }),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, " References to resources with relevance to all TSG companies and business units. ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LinkBox, {
            route: "ruleof40",
            title: "Rule of 40",
            description: "Explanation and visualization of the Rule of 40"
          })
        ])
      ]),
      _: 1,
      __: [1]
    })
  ], 64))
}
}

})